// Shared TanStack Query client — the one cache for the whole app.
//
// "Mobile-style" data freshness (founder ruling 2026-05-29): show cached data
// instantly, refetch silently in the background on return-to-screen and on
// window focus, with a short staleTime so focus changes don't hammer the DB.
// Per-endpoint overrides (staleTime / refetchInterval) live at the call site.
//
// IMPORTANT: keep expensive / LLM-backed reads OFF aggressive refetch — pass a
// long staleTime and disable refetchInterval at the call site. The default here
// targets cheap RLS-gated read RPCs (boards, counts, cards).

import { QueryClient } from "@tanstack/react-query";

export const DEFAULT_STALE_MS = 30_000; // 30s — cached data is "fresh" this long
export const DEFAULT_GC_MS = 5 * 60_000; // 5min — keep unused cache before GC

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_MS,
      gcTime: DEFAULT_GC_MS,
      refetchOnWindowFocus: true, // refetch when the tab/window regains focus
      refetchOnReconnect: true,
      refetchOnMount: true, // refetch on return-to-screen if stale
      retry: 1,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: 0,
    },
  },
});
